import loadable from '@loadable/component'

export const EntityHeader = loadable(() => import('./EntityHeader'))
export type {
  EntityHeaderRenderLinkProps,
  EntityHeaderTagItemProps,
  EntityHeaderTagsProps,
  EntityHeaderProps
} from './EntityHeader'
